import { ParamsProps, ReturnType } from "./types";
import request from "@utils/request";

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "withdrawals",
      method: "get",
      authorization: true,
      params: args?.params,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const create = async (args: { data: any }) => {
  try {
    const config: ReturnType = {
      url: "withdrawals/request",
      method: "post",
      authorization: true,
      data: args.data,
      config: {
        successMsg: "Withdrawal request submitted successfully",
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const approve = async (args: { id: number; data: any }) => {
  try {
    const config: ReturnType = {
      url: `withdrawals/${args.id}/approve`,
      method: "patch",
      authorization: true,
      data: args.data,
      config: {
        successMsg: "Withdrawal approved successfully",
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const reject = async (args: { id: number; data: any }) => {
  try {
    const config: ReturnType = {
      url: `withdrawals/${args.id}/reject`,
      method: "patch",
      authorization: true,
      data: args.data,
      config: {
        successMsg: "Withdrawal rejected successfully",
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const cancel = async (args: { id: number }) => {
  try {
    const config: ReturnType = {
      url: `withdrawals/${args.id}/cancel`,
      method: "patch",
      authorization: true,
      config: {
        successMsg: "Withdrawal request cancelled and refunded",
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const updateReceipt = async (args: { id: number; data: any }) => {
  try {
    const config: ReturnType = {
      url: `withdrawals/${args.id}/receipt`,
      method: "patch",
      authorization: true,
      data: args.data,
      config: {
        successMsg: "Receipt uploaded successfully",
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getStats = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "withdrawals/stats",
      method: "get",
      authorization: true,
      params: args?.params,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  list,
  getStats,
  create,
  approve,
  reject,
  cancel,
  updateReceipt,
};
